/* global ajaxObject */

const searchAjaxRoot = document.querySelector('.js-search-ajax__root')
const searchAjaxTrigger = document.querySelector('.js-search-ajax__trigger')
const searchAjaxInput = document.querySelector('.js-search-ajax__input')
const searchAjaxDataFetch = document.querySelector(
  '.js-search-ajax__data-fetch',
)
const searchAjaxOverlay = document.querySelector('.js-search-ajax__overlay')
const searchAjaxContent = document.querySelector('.js-search-ajax__content')
const searchAjaxInputCancelButton = document.querySelector(
  '.js-search-ajax__input-cancel-button',
)

const searchAjaxAdminUrl =
  typeof ajaxObject !== 'undefined' && typeof ajaxObject.ajaxUrl !== 'undefined'
    ? ajaxObject.ajaxUrl
    : null

function fetchResults() {
  if (!searchAjaxInput) {
    console.error('searchAjaxInput was not found in the DOM.')
    return
  }

  const keyword = searchAjaxInput.value.trim()

  if (keyword === '') {
    const searchAjaxText = document.createElement('p')

    searchAjaxText.textContent = 'Faça sua busca...'
    searchAjaxText.classList.add('dialog-search__text')
    searchAjaxDataFetch.innerHTML = ''
    searchAjaxDataFetch.appendChild(searchAjaxText)
    return
  }

  if (!searchAjaxAdminUrl) {
    console.error('ajaxObject.ajaxUrl not found')
    return
  }

  const formData = new URLSearchParams()
  formData.append('action', 'data_fetch')
  formData.append('keyword', keyword)

  if (typeof ajaxObject !== 'undefined' && ajaxObject.nonce) {
    formData.append('nonce', ajaxObject.nonce)
  }

  fetch(searchAjaxAdminUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: formData.toString(),
  })
    .then((response) => {
      if (response.ok) {
        return response.text()
      }

      throw new Error(`AJAX request error: ${response.status}`)
    })
    .then((data) => {
      searchAjaxDataFetch.innerHTML = data.trim() === '' ? '' : data
    })
    .catch((error) => {
      console.error('Error:', error)
      searchAjaxDataFetch.innerHTML =
        '<p class="dialog-search__no-results-found">Erro na busca. Tente novamente.</p>'
    })
}

const updateSearchAjaxState = (state) => {
  if (
    !searchAjaxRoot ||
    !searchAjaxTrigger ||
    !searchAjaxContent ||
    !searchAjaxOverlay
  ) {
    return
  }

  const isClose = state === 'closed'
  const isOpen = state === 'open'

  searchAjaxRoot.setAttribute('data-state', state)
  searchAjaxRoot.setAttribute('aria-hidden', isClose ? 'true' : 'false')
  searchAjaxRoot.setAttribute('tabindex', isClose ? '-1' : '0')

  searchAjaxTrigger.setAttribute('data-state', state)
  searchAjaxTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false')

  searchAjaxContent.setAttribute('data-state', state)
  searchAjaxOverlay.setAttribute('data-state', state)
}

const openSearchAjax = () => {
  updateSearchAjaxState('open')
  document.body.style.pointerEvents = 'none'
  document.body.style.overflow = 'hidden'

  if (searchAjaxRoot) {
    searchAjaxRoot.style.opacity = '1'
    searchAjaxRoot.style.pointerEvents = 'auto'
  }

  searchAjaxInput?.focus()

  fetchResults()
}

if (searchAjaxInput && searchAjaxInputCancelButton) {
  searchAjaxInputCancelButton.setAttribute('data-state', 'closed')

  searchAjaxInput.addEventListener('input', () => {
    const inputState = searchAjaxInput.value.trim() === '' ? 'closed' : 'open'

    searchAjaxInputCancelButton.setAttribute('data-state', inputState)
  })

  searchAjaxInputCancelButton.addEventListener('click', () => {
    searchAjaxInput.value = ''
    searchAjaxInput.focus()
    fetchResults()
  })
}

const closeSearchAjax = () => {
  updateSearchAjaxState('closed')
  document.body.style.pointerEvents = ''
  document.body.style.overflow = ''

  searchAjaxRoot.style.opacity = '0'
  searchAjaxRoot.style.pointerEvents = 'none'

  if (searchAjaxInput) {
    searchAjaxInput.value = ''
  }

  searchAjaxInputCancelButton?.setAttribute('data-state', 'closed')

  searchAjaxTrigger?.focus()
}

const handleEscapeKey = (e) => {
  if (e.key === 'Escape' && !e.shiftKey) {
    if (searchAjaxRoot.getAttribute('data-state') === 'open') {
      e.preventDefault()
      closeSearchAjax()
    }
  }
}

searchAjaxOverlay?.addEventListener('click', closeSearchAjax)

searchAjaxTrigger?.addEventListener('click', openSearchAjax)

if (handleEscapeKey) {
  document.addEventListener('keydown', handleEscapeKey)
}
